module.exports = __webpack_public_path__ + "static/img/v_ad.2407878.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v_ad.jpeg
// module id = BivZ
// module chunks = 1